
import React from 'react'
import { List, Typography, Select, Space } from 'antd'

import useReporteResultadoExamenCarrera from '../hooks/adminexamen/useReporteResultadoExamenCarrera'

const { Link } = Typography;

const ReporteResultadoExamenCarrera = () => {

    const { carreras, loading, traerReporte, Option, datosFechasAplicacion, setFechaSeleccionada } = useReporteResultadoExamenCarrera()

  return (
    <>
        <Space>
            <p>Filtrar los resultados por fecha de aplicación:</p>

            <Select
                showSearch
                placeholder="Fecha de aplicación"
                optionFilterProp="children"
                onChange={ setFechaSeleccionada }
                filterOption={(input, option) => option.value.includes(input)}
            >

                {datosFechasAplicacion.map((e, i) => (

                    <Option key={i} value={e["fecha"]} > {e["fecha"]} </Option>

                ))}

            </Select>
        </Space>
        <br/>
        <br/>


        <List
            loading={ loading }
            size="large"
            header={ <div className='ta-center'>Seleccione una carrera para generar PDF</div> }
            bordered
            dataSource={ carreras }
            renderItem={item => {
                return(
                    <List.Item>
                        <Link className='link-carrera' target='_blank' onClick={ () => traerReporte( item.pk_carrera, item.nom_carrera ) } >
                            {item.nom_carrera}
                        </Link>
                    </List.Item>
                )
            }}
        />
    </>
  )
}

export default ReporteResultadoExamenCarrera
